import { Link, isRouteErrorResponse, useRouteError } from "react-router-dom";
import { Button, Layout, theme } from "antd";
import { isUserLoggedIn } from "../../axios_helper.js";
import NotFoundPage from "./NotFoundPage.js";
import Seo from "./Seo.js";
import "./RouteErrorPage.css";

export default function RouteErrorPage() {
  const error = useRouteError();
  const { token } = theme.useToken();

  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;

  return (
    <>
      <Seo title="Unable to load this page | Age of Companies" description="This page could not be loaded. Please try again." noIndex />
      <Layout className="route-error-layout" style={{ padding: "16px" }}>
        <Layout.Content style={{ padding: 16, margin: 0, minHeight: 280, background: token.colorBgContainer, borderRadius: token.borderRadiusLG }}>
          <main id="main-content" className="route-error-page" aria-labelledby="route-error-heading">
            <div>
              <h1 id="route-error-heading">Unable to load this page</h1>
              <p style={{ color: token.colorTextSecondary }}>Something went wrong while opening this page. Please try again.</p>
              <div className="route-error-actions">
                <Button type="primary" onClick={() => window.location.reload()}>Retry</Button>
                <Link to={isUserLoggedIn() ? "/me/dailyreport" : "/"}>Return to Age of Companies</Link>
              </div>
            </div>
          </main>
        </Layout.Content>
      </Layout>
    </>
  );
}
